<div class="cookie-banner" *ngIf="isVisible">
  <p>
    <app-icon name="cookie" [size]="IconSize.Medium" class="cookie-icon"></app-icon>
    {{ 'cookieBanner.message' | translate }}
    <a [routerLink]="privacyLink" target="_blank">{{ 'cookieBanner.privacyPolicy' | translate }}</a>.
  </p>
  <div class="actions">
    <button (click)="decline()">{{ 'cookieBanner.decline' | translate }}</button>
    <button (click)="acceptAll()">{{ 'cookieBanner.accept' | translate }}</button>
  </div>
</div>



